
import RowItem from '@/components/detail/row_item/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services'

@Component({
    name: 'OrgDetail',
    components: {
        RowItem,
        RowWrap
    }
})
export default class extends Vue {
    private isLoading = true
    private orgId = ''
    private detail: any = {
        name: '',
        url: '',
        intro: '',
        medias: [],
        media_count: 0,
        created_at: '',
        updated_at: ''
    }

    private mounted() {
        this.orgId = this.$route.params.id
        this.fetchOrgDetail(parseInt(this.orgId))
    }
    private async fetchOrgDetail(orgId: number) {
        try {
            const result = await MediaService.getOrgDetail({ id: orgId })
            console.log('完整响应', result)
            console.log('接口内层数据', result.data) // 这里打印应该是集团对象

            if (result.status === 200) {
                // 直接取 result.data，不是 result.data.data！
                this.detail = result.data || {}
            }
        } catch (err) {
            console.error('请求出错：', err)
            this.detail = {} // 兜底赋值，避免 undefined
        } finally {
            this.isLoading = false // 无论成功失败，都关闭 loading
        }
    }
    

    private goBack() {
        this.$router.push({ name: 'MediaOrgList' })
    }

    private goEdit() {
        this.$router.push({ name: 'MediaOrgEdit', params: { id: this.orgId } })
    }
}
